import React from "react";

export default function Terms() {
  return (
    <section className="page-container">
      <h2>Terms and Conditions</h2>

      <p>These Terms and Conditions ("Terms") govern your use of Berkinson’s
      website and services. By accessing or using our services, you agree to
      these Terms.</p>

      <h3>1. Service</h3>
      <p>Berkinson offers dry cleaning, laundry, and related services. You
      authorize us to handle garments for cleaning and finishing.</p>

      <h3>2. Eligibility</h3>
      <p>By using our services, you represent that you are at least 18 years
      old and capable of entering into a binding agreement.</p>

      <h3>3. Liability</h3>
      <p>We handle garments with care. However, we are not responsible for
      damage caused by pre‑existing defects or manufacturer weaknesses.</p>

      <h3>4. Payments</h3>
      <p>Service fees must be paid via provided options (card, cash, invoice)
      before or upon delivery, as outlined during booking.</p>

      <h3>5. Cancellations</h3>
      <p>Cancellations must be submitted at least 24 hours before pickup.
      Late cancellations may be subject to fees.</p>

      <h3>6. Governing Law</h3>
      <p>These Terms are governed by the laws of Oregon, USA. Disputes shall be
      resolved under Oregon jurisdiction.</p>

      <h3>Contact</h3>
      <p>Questions? Email <a href="mailto:support@berkinson.com">support@berkinson.com</a>.</p>

      <p>Last updated: December 2025</p>
    </section>
  );
}
